import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Switch, Route } from 'react-router';

import RouteEndPoints from './utilities/RouteEndPoints';
import './App.css';

import MainLayout from './containers/MainLayout/MainLayout';

// import Footer from './components/Navigation/Footer/Footer';

import ShowLoader from './hoc/ShowLoader/ShowLoader';
import { connect } from 'react-redux';
import ModuleDetailsPage from './containers/ProgramManagerPages/ModuleDetailsPage/ModuleDetailsPage';
import UpdateJobProfile from './containers/UpdateJobProfile/UpdateJobProfile';
import CustomerSupport from './containers/CustomerSupport/CustomerSupport';

// import Homepage from './containers/Homepage/Homepage';
const PreLoginHomepage = React.lazy(() => import('./containers/Homepage/PreLoginHomepage/PreLoginHomepage'));
const PostLoginHomepage = React.lazy(() => import('./containers/Homepage/PostLoginHomepage/PostLoginHomepage'));
const AiLabsCatalogPage = React.lazy(() => import('./containers/AiLabs/AiLabsCatalogPage/AiLabsCatalogPage'));
const AiLabDetailPage = React.lazy(() => import('./containers/AiLabs/AiLabDetailPage/AiLabDetailPage'));
const AiLabSolvePage = React.lazy(() => import('./containers/AiLabs/AiLabSolvePage/AiLabSolvePage'));
const AiLabPortfolioPage = React.lazy(() => import('./containers/AiLabs/AiLabPortfolioPage/AiLabPortfolioPage'));
const AiLabCertificatePage = React.lazy(() => import('./containers/AiLabs/AiLabCertificatePage/AiLabCertificatePage'));
const AiLabSolutionPage = React.lazy(() => import('./containers/AiLabs/AiLabSolutionPage/AiLabSolutionPage'));
const ModulesPage = React.lazy(() => import('./containers/ModulesPage/NewModulesPage'));
const InstructorsPage = React.lazy(() => import('./containers/InstructorsPage/InstructorsPage'));
const SubmissionsPage = React.lazy(() => import('./containers/SubmissionsPage/SubmissionsPage'));
const PerformancePage = React.lazy(() => import('./containers/PerformancePage/PerformancePage'));
const BatchmatesPage = React.lazy(() => import('./containers/BatchmatesPage/BatchmatesPage'));
const NotFound404 = React.lazy(() => import('./containers/404NotFound/404NotFound'));
const CreateNotificationsPage = React.lazy(() => import('./containers/CreateNotifications/CreateNotifications'));
const FAQsPage = React.lazy(() => import('./containers/FAQPage/FAQPage'));
const NotificationsPage = React.lazy(() => import('./containers/NotificationsPage/NotificationsPage'));
const QuizPage = React.lazy(() => import('./containers/QuizPage/QuizPage'));
const ProfilePage = React.lazy(() => import('./containers/ProfilePage/ProfilePage'));
const ProfilePagePublic = React.lazy(() => import('./containers/ProfilePagePublic/ProfilePagePublic'));
const EditProfilePage = React.lazy(() => import('./containers/EditProfilePage/EditProfilePage'));
const ServerError500 = React.lazy(() => import('./containers/500ServerError/500ServerError'));
const Unauthorized401 = React.lazy(() => import('./containers/401Unauthorized/401Unauthorized'));
const ChangePasswordPage = React.lazy(() => import('./containers/ChangePasswordPage/ChangePasswordPage'));
const ResetPasswordPage = React.lazy(() => import('./containers/ResetPassword/ResetPassword'));
const LoginPage = React.lazy(() => import('./containers/LoginPage/LoginPage'));
const CurriculumPage = React.lazy(() => import('./containers/CurriculumPage/CurriculumPage'));
const AllModulesPage = React.lazy(() => import('./containers/AllModulesPage/AllModulesPage'));
const PlannerPage = React.lazy(() => import('./containers/PlannerPage/PlannerPage'));
const EvaluationPage = React.lazy(() => import('./containers/EvaluationPage/EvaluationPage'));
const ModuleCurriculumTab = React.lazy(() => import('./components/ProgramManagerPageSections/ManageProgramsPage/ModuleCurriculumTab/ModuleCurriculumTab'));
const ViewSubmissionSection = React.lazy(() => import('./components/EvaluationPageSections/ViewSubmissionSection/ViewSubmissionSection'))
const LearnerLiveSessionPage = React.lazy(() => import('./containers/LearnerLiveSessionPage/LearnerLiveSessionPage'));
const LearnerFeedbackPage = React.lazy(() => import('./containers/LearnerFeedbackPage/LearnerFeedback'));
const ReportsPage = React.lazy(() => import('./containers/ReportsPage/ReportsPage'));
const ProgramAnalyticsPage = React.lazy(() => import('./containers/ProgramManagerPages/ProgramAnalyticsPage/ProgramAnalyticsPage'));
const ManageProgramsPage = React.lazy(() => import('./containers/ProgramManagerPages/ManageProgramsPage/ManageProgramsPage'));
const TemplatesPage = React.lazy(() => import('./containers/ProgramManagerPages/TemplatesPage/TemplatesPage'));
const UsersPage = React.lazy(() => import('./containers/ProgramManagerPages/UsersPage/UsersPage'));
const ContactUsPage = React.lazy(() => import('./containers/ContactUsPage/ContactUsPage'));
const ProgramDetailsPage = React.lazy(() => import('./containers/ProgramManagerPages/ProgramDetailsPage/ProgramDetailsPage'));
const ModuleCurriculumPage = React.lazy(() => import('./containers/ProgramManagerPages/ModuleCurriculumPage/ModuleCurriculumPage'));
const ProgramCurriculumPage = React.lazy(() => import('./containers/ProgramManagerPages/ProgramCurriculumPage/ProgramCurriculumPage'));
const ManageReportsPage = React.lazy(() => import('./containers/ProgramManagerPages/ManageReportsPage/ManageReportsPage'));
const EvaluationPagePM = React.lazy(() => import('./containers/ProgramManagerPages/EvaluationPage/EvaluationPagePM'));
const CertificationHomepage = React.lazy(() => import('./containers/CertificationPages/CertificationHomepage/CertificationHomepage'));
const CertificationDetailsPage = React.lazy(() => import('./containers/CertificationPages/CertificationDetailsPage/CertificationDetailsPage'));
const ReattemptFormPage = React.lazy(() => import('./containers/CertificationPages/ReattemptFormPage/ReattemptFormPage'));
const CertificationThankYouPage = React.lazy(() => import('./containers/CertificationPages/CertificationThankYouPage/CertificationThankYouPage'));
const CertificationPendingPage = React.lazy(() => import('./containers/CertificationPages/CertificationPendingPage/CertificationPendingPage'));
const CertificationsTab = React.lazy(() => import('./containers/CertificationsTab/CertificationsTab'));
const ReferralPage = React.lazy(() => import('./containers/ReferralPage/ReferralPage'));
const ClaimRewardsPage = React.lazy(() => import('./containers/ClaimRewardsPage/ClaimRewardsPage'));
const HomepageCarousal = React.lazy(() => import('./containers/Homepage/CarousalCard/HomepageCarousal'));
const JobsListPage = React.lazy(() => import("./containers/JobsListPage/JobsListPage"));
const JobsDetailsPage = React.lazy(() => import('./containers/JobsDetailsPage/JobsDetailsPage'));
const SupportChatPage = React.lazy(() => import('./containers/SupportChatPage/SupportChatPage'));
const FeatureRequestsPage = React.lazy(() => import('./containers/FeatureRequestsPage/FeatureRequestsPage'));
const DiscourseLoginPage = React.lazy(() => import('./containers/DiscourseLoginPage/DiscourseLoginPage'));
const ProfileCertificate = React.lazy(() => import('./containers/ProfileCertificatePage/ProfileCertificatePage'));
const PublicMDCertificatePage = React.lazy(() => import('./containers/PublicMDCertificatePage/PublicMDCertificatePage'));
const CareerTrackProgramsPage = React.lazy(() => import('./containers/CareerTrackProgramsPage/CareerTrackProgramsPage'));
const UpdateCertificationDetailsPage = React.lazy(() => import('./containers/CertificationPages/UpdateCertificationDetailsPage/UpdateCertificationDetailsPage'));
const CategoriesPage = React.lazy(() => import('./containers/MicroDegreeListingPage/MicroDegreeListingPage'));
const CataloguePage = React.lazy(() => import('./containers/B2BCataloguePage/CataloguePage'));
const CourseDetailsPage = React.lazy(() => import('./containers/B2BCourseDetailsPage/CourseDetailsPage'));
const JobProgramsPage = React.lazy(() => import('./containers/JobProgramsPage/JobProgramsPage'));

// const Footer = React.lazy(() => import('./components/Navigation/Footer/Footer'));

class App extends React.Component {

  componentDidMount() {
    // Inject Tawk.to chat widget script globally
    if (!document.getElementById('tawk-script')) {
      // Initialize Tawk API
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();

      // Create and inject the script
      const script = document.createElement('script');
      script.id = 'tawk-script';
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://embed.tawk.to/685f76933007ee19156e5c7b/1iuqeecp5';
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');

      // Insert the script
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }

  render() {
    return (
      <div className="App">

        <BrowserRouter>
          <MainLayout />
          <Suspense fallback={<ShowLoader />}>
            <Switch>
              <Route exact path={RouteEndPoints.AI_LABS_PAGE} component={AiLabsCatalogPage} />
              <Route exact path={RouteEndPoints.AI_LAB_PORTFOLIO_PAGE} component={AiLabPortfolioPage} />
              <Route path={RouteEndPoints.AI_LAB_CERTIFICATE_PAGE + '/:publicId'} component={AiLabCertificatePage} />
              <Route path={RouteEndPoints.AI_LAB_SOLUTION_PAGE + '/:attemptId'} component={AiLabSolutionPage} />
              <Route path={RouteEndPoints.AI_LAB_SOLVE_PAGE + '/:slug/solve'} component={AiLabSolvePage} />
              <Route path={RouteEndPoints.AI_LAB_DETAIL_PAGE + '/:slug'} component={AiLabDetailPage} />
              <Route path={RouteEndPoints.PROGRAM_MODULES_PAGE + '/:batchCode?/:moduleName?/:topicId?/'} component={ModulesPage} />
              <Route path={RouteEndPoints.PROGRAM_INSTRUCTORS_PAGE} component={InstructorsPage} />
              <Route path={RouteEndPoints.PROGRAM_SUBMISSIONS_PAGE + '/:batchCode?'} component={SubmissionsPage} />
              <Route path={RouteEndPoints.PROGRAM_PERFORMANCE_PAGE + '/:batchCode?'} component={PerformancePage} />
              <Route path={RouteEndPoints.BATCHMATES_PAGE + '/:batchCode?'} component={BatchmatesPage} />
              <Route path={RouteEndPoints.PROGRAM_CERTIFICATIONS_PAGE + '/:batchCode/:certificationCode?'} component={CertificationsTab} />
              <Route path={RouteEndPoints.ALL_NOTIFICATIONS} component={NotificationsPage} />
              <Route path={RouteEndPoints.CREATE_NOTIFICATIONS} component={CreateNotificationsPage} />
              <Route path={RouteEndPoints.PUBLIC_PROFILE + '/:username'} component={ProfilePagePublic} />
              <Route path={RouteEndPoints.EDIT_PROFILE + '/:username'} component={EditProfilePage} />
              <Route path={RouteEndPoints.MY_PROFILE + '/:username'} component={ProfilePage} />
              <Route path={RouteEndPoints.QUIZ_PAGE + '/:quizId'} component={QuizPage} />
              <Route path={RouteEndPoints.CHANGE_PASSWORD_PAGE} component={ChangePasswordPage} />
              <Route path={RouteEndPoints.RESET_PASSWORD + '/:id/:token'} component={ResetPasswordPage} />
              <Route path={RouteEndPoints.LOGIN_PAGE} component={LoginPage} />

              <Route path={RouteEndPoints.WELCOME_PAGE} component={HomepageCarousal} />

              <Route path={RouteEndPoints.LIVE_SESSION_PAGE} component={LearnerLiveSessionPage} />
              <Route path={RouteEndPoints.FEEDBACK_PAGE + '/:sessionId'} component={LearnerFeedbackPage} />

              <Route path={RouteEndPoints.ALL_MODULES_PAGE} component={AllModulesPage} />
              <Route path={RouteEndPoints.CURRICULUM_PAGE + '/:batchCode?/:moduleName?/:topicType?/:topicId?/'} component={CurriculumPage} />
              <Route path={RouteEndPoints.PLANNER_PAGE + '/:moduleName?/'} component={PlannerPage} />
              <Route path={RouteEndPoints.EVALUATION_PAGE + '/:batchCode?/:moduleName?/quiz/:topicId?/view-submissions/:userId?/'} component={ViewSubmissionSection} />
              <Route path={RouteEndPoints.EVALUATION_PAGE + '/:batchCode?/:moduleName?/:topicType?/:topicId?/:evaluate?/:userId?'} component={EvaluationPage} />
              <Route path={RouteEndPoints.REPORTS_PAGE + '/:reportType?/:feedbackId?'} component={ReportsPage} />
              <Route path={RouteEndPoints.CONTACT_US_PAGE} component={ContactUsPage} />
              <Route path={RouteEndPoints.CUSTOMER_SUPPORT_PAGE} component={CustomerSupport} />
              <Route path={RouteEndPoints.UPDATE_JOB_PROFILE} component={UpdateJobProfile} />

              <Route path={RouteEndPoints.PROGRAM_ANALYTICS_PAGE} component={ProgramAnalyticsPage} />
              <Route path={RouteEndPoints.PROGRAMS_PAGE + '/:batchCode/modules/:moduleName/evaluation/quiz/view-submissions/:topicId/:userId'} component={ViewSubmissionSection} />
              <Route path={RouteEndPoints.PROGRAMS_PAGE + '/:batchCode/modules/:moduleName/evaluation/:topicType?/:topicId?/:userId?'} component={EvaluationPagePM} />
              <Route path={RouteEndPoints.PROGRAMS_PAGE + '/:batchCode/modules/:moduleName/curriculum/:topicType?/:topicId?'} component={ModuleCurriculumTab} />
              <Route path={RouteEndPoints.PROGRAMS_PAGE + '/:batchCode/modules/:moduleName/:activeTab?'} component={ModuleDetailsPage} />
              <Route path={RouteEndPoints.PROGRAMS_PAGE + '/:batchCode/:activePageType?'} component={ProgramDetailsPage} />
              <Route path={RouteEndPoints.PROGRAMS_PAGE} component={ManageProgramsPage} />
              <Route path={RouteEndPoints.MANAGE_REPORTS_PAGE + '/:reportType?'} component={ManageReportsPage} />

              <Route path={RouteEndPoints.TEMPLATES_PAGE + '/programs/curriculum/:batchCode?/:moduleName?/:topicId?/'} component={ProgramCurriculumPage} />
              <Route path={RouteEndPoints.TEMPLATES_PAGE + '/modules/curriculum/:batchCode?/:moduleName?/:topicType?/:topicId?/'} component={ModuleCurriculumPage} />
              <Route path={RouteEndPoints.TEMPLATES_PAGE + '/:templateType?'} component={TemplatesPage} />
              <Route path={RouteEndPoints.USERS_PAGE + '/:userType?/:pageType?/:username?/:batchCode?'} component={UsersPage} />
              <Route exact={true} path={RouteEndPoints.CERTIFICATION_THANK_YOU_PAGE} component={CertificationThankYouPage} />
              <Route exact={true} path={RouteEndPoints.CERTIFICATION_PENDING_APPLICATION_PAGE} component={CertificationPendingPage} />
              <Route path={RouteEndPoints.CERTIFICATION_PAGE + '/reattempt/:batchCode/:id?'} component={ReattemptFormPage} />
              <Route path={RouteEndPoints.CERTIFICATION_PAGE + '/:id'} component={CertificationDetailsPage} />
              <Route path={RouteEndPoints.CERTIFICATION_PAGE} component={CertificationHomepage} />
              <Route path={RouteEndPoints.REFERRAL_PAGE} component={ReferralPage} />
              <Route path={RouteEndPoints.REDEEM_REWARDS_PAGE} component={ClaimRewardsPage} />
              {
                !this.props.userLoggedIn
                  ? <Route path='/' exact={true} component={PreLoginHomepage} />
                  : <Route path='/' exact={true} component={PostLoginHomepage} />
              }

              <Route path={RouteEndPoints.PLACEMENTS} exact={true} component={JobsListPage} />
              <Route path={RouteEndPoints.PLACEMENTS + '/:id'} component={JobsDetailsPage} />
              <Route path={RouteEndPoints.PROFILE_CERTIFICATE + '/:username'} component={ProfileCertificate} />
              <Route path={RouteEndPoints.PUBLIC_MD_CERTIFICATE_PAGE + '/:username/:batchCode'} component={PublicMDCertificatePage} />
              <Route path={RouteEndPoints.CAREER_TRACK_PROGRAMS} component={CareerTrackProgramsPage} />

              <Route path={RouteEndPoints.UPDATE_CERTIFICATION_DETAILS_PAGE + '/:certificationCode'} component={UpdateCertificationDetailsPage} />

              <Route path={RouteEndPoints.SUPPORT_CHAT} component={SupportChatPage} />
              <Route path={RouteEndPoints.FEATURE_REQUESTS_PAGE} component={FeatureRequestsPage} />

              <Route path={RouteEndPoints.CATEGORIES_PAGE} component={CategoriesPage} />
              <Route path={RouteEndPoints.CATALOGUE_PAGE} component={CataloguePage} />
              <Route path={RouteEndPoints.B2B_COURSE_DETAILS_PAGE + '/:id'} component={CourseDetailsPage} />
              <Route path={RouteEndPoints.JOB_PROGRAMS_PAGE} component={JobProgramsPage} />

              <Route path={RouteEndPoints.DISCOURSE_LOGIN} component={DiscourseLoginPage} />

              <Route path={RouteEndPoints.SERVER_ERROR} component={ServerError500} />
              <Route path={RouteEndPoints.UNAUTHORIZED_ERROR} component={Unauthorized401} />
              <Route path={RouteEndPoints.NOT_FOUND} component={NotFound404} />
              <Route path={RouteEndPoints.FAQ_PAGE} component={FAQsPage} />

            </Switch>
          </Suspense>

        </BrowserRouter>
      </div >
    );
  }
}

const mapStateToProps = state => {
  return {
    userLoggedIn: state.userLoggedIn
  }
}


export default connect(mapStateToProps)(App);